import clsx from 'clsx';
import React from 'react';

import styles from './styles.module.css';

export const MarkdownQuote = ({ ...props }) => {
  return React.createElement(`span`, {
    className: clsx(styles.quote),
    ...props,
  });
};
